import React, {Component} from 'react';
import * as actions from "../../store/actions";
import connect from "react-redux/es/connect/connect";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import {Chart} from "react-google-charts";
import {arrayToDataTable} from "../../config/Utils";
import countries from "../../../assets/country_codes";
import './ATCStatistics.css'
import Aux from 'react-aux'
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import TableHead from "@material-ui/core/TableHead";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";

class ATCStatistics extends Component {

    state = {
        loading: false,
        availableCountries: [],
        selectedCountry: 'BE',
        treeMapDataPreprocessed: [],
        parentAndDrugGroups: null,
        atcGroupsDict: new Map()
    };

    // noinspection JSCheckFunctionSignatures
    shouldComponentUpdate(nextProps, nextState) {

        /*
        * Because of the large data, the data preprocessing is done here,
        * only once, if the props change, instead of every chart render
        */

        if (nextProps.drugsPerATC && this.props.drugsPerATC !== nextProps.drugsPerATC) {
            let atcGroupMapper = new Map()
            for (const {atcCode, atcName, parent, atcLevel} of nextProps.drugsPerATC) {
                let handleNullParent = parent != null ? parent : 'Browse Drugs'
                let mapItem = atcGroupMapper.get(handleNullParent)
                if (mapItem) {
                    mapItem.push({
                        level: atcLevel,
                        atcCode: atcCode,
                        atcName: atcName
                    })
                } else {
                    atcGroupMapper.set(handleNullParent, [{
                        level: atcLevel,
                        atcCode: atcCode,
                        atcName: atcName
                    }])
                }
            }

            let treeMapData = nextProps.drugsPerATC
                .filter(drug => drug.parent !== 'Error') // NOTE: handles error cells
                .map(drug => {
                    return {
                        atcCode: drug.atcCode,
                        parent: drug.parent ? drug.parent : 'Browse Drugs',
                        drugsCount: drug.drugsCount,
                        color: 1
                    }
                })

            treeMapData = arrayToDataTable(treeMapData)
            treeMapData.push(['Browse Drugs', null, 45000, 12])
            let selectedAtcGroup = 'Browse Drugs'
            this.setState({
                treeMapDataPreprocessed: treeMapData,
                atcGroupsDict: atcGroupMapper,
                parentAndDrugGroups: {
                    parent: selectedAtcGroup,
                    children: atcGroupMapper.get(selectedAtcGroup)
                }
            })
        }

        if (nextProps.atcCountriesCount && this.props.atcCountriesCount !== nextProps.atcCountriesCount) {
            let distinctCountryCodes = new Set([...nextProps.atcCountriesCount
                .filter(c => c.countryCode != null && c.countryCode !== '')
                .map(c => c.countryCode)])

            this.setState({
                availableCountries: [...distinctCountryCodes],
                selectedCountry: [...distinctCountryCodes][0]
            })
        }

        return true;
    }

    componentDidMount() {
        this.setState({loading: true});
        this.props.onATCCountriesCountFetch();
        this.props.onDrugsPerATC("BE");
        this.setState({loading: false});
    }


    renderSelections = (countryCodes) => {
        let res = []
        for (const key of countryCodes) {
            res.push(
                <option key={key} value={key}>{countries[key]}</option>
            )
        }
        return res
    }

    countryChange = (event) => {
        this.setState({
            selectedCountry: event.target.value
        })
        this.props.onDrugsPerATC(this.state.selectedCountry);
    }

    drawTreeMap = () => {
        return (
            <div className='px-5'>
                <span className='text-secondary'>Larger areas indicate larger number of drugs in given ATC Group</span>
                <Chart
                    height={'100%'}
                    chartType={"TreeMap"}
                    loader={<div style={{minHeight: '40vh'}}
                                 className='d-flex align-items-center justify-content-center'>
                        <CircularProgress/>
                    </div>}
                    data={this.state.treeMapDataPreprocessed}
                    chartEvents={[
                        {
                            callback: ({chartWrapper}) => {
                                let chart = chartWrapper.getChart()
                                let dataTable = chartWrapper.getDataTable()
                                let {row} = chart.getSelection()[0]
                                let selectedAtcGroup = dataTable.getValue(row, 0);
                                this.setState({
                                    parentAndDrugGroups: {
                                        parent: selectedAtcGroup,
                                        children: this.state.atcGroupsDict.get(selectedAtcGroup)
                                    }
                                })
                                if (selectedAtcGroup.length === 7 && this.state.selectedCountry)
                                    this.props.fetchTable(this.state.selectedCountry, selectedAtcGroup);
                            },
                            eventName: "select"
                        }
                    ]}
                    options={{
                        highlightOnMouseOver: true,
                        maxDepth: 1,
                        maxPostDepth: 2,
                        minColor: '#a8eb12',
                        midColor: '#008793',
                        maxColor: '#051937',
                        minHighlightColor: '#5ffbf1',
                        midHighlightColor: '#79b3f4',
                        maxHighlightColor: '#8c6bb1',
                        headerHeight: 25,
                        headerColor: '#008793',
                        showScale: true,
                        fontColor: 'white',
                        height: 500,
                        useWeightedAverageForAggregation: true,
                        generateTooltip: (row, size, value) => this.generateTooltip(row, size, value),

                    }}
                />
            </div>
        )
    };

    renderAtcInfo = () => {
        if (this.state.parentAndDrugGroups) {
            let item = this.state.parentAndDrugGroups
            if (item.children) {
                return (
                    <Aux>
                        <h3>
                            Level {item.children[0]['level']}: {item.parent}
                        </h3>
                        <ul>
                            {
                                this.state.parentAndDrugGroups.children.map(chd => {
                                    return (
                                        <li key={chd.atcCode}>
                                            <b>{chd.atcCode}</b> {chd.atcName}
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    </Aux>
                )
            } else {
                return (
                    <h3>
                        Level 5: {item.parent}
                    </h3>
                )
            }
        }
    }

    render() {
        if (this.state.loading || !this.props.atcCountriesCount) {
            return <div className='d-flex align-items-center justify-content-center' style={{minHeight: '60vh'}}>
                <CircularProgress/></div>
        }
        return (
            <div className='ibox'>
                <div className='ibox-title bg-success text-light text-center'>
                    <h3>The ATC Classification System</h3>
                </div>
                <div className='ibox-content'>
                    <div className='row'>
                        <div className='col-12 text-justify px-5'>
                            <b>The Anatomical Therapeutic Chemical (ATC) Classification System</b> is used
                            for the classification of active ingredients of drugs according to the organ or
                            system on which they act and their therapeutic, pharmacological and chemical properties.
                            It is controlled by the World Health Organization Collaborating Centre for Drug Statistics
                            Methodology (WHOCC), and was first published in 1976.
                        </div>
                    </div>
                    <div className='mt-5 row'>
                        <div className="col-6 px-5">
                            <div className="form-group">
                                <label className={'font-weight-bold'}>Country: </label>
                                <select onChange={this.countryChange}
                                        value={this.state.selectedCountry}
                                        className={'form-control mb-3 pb-1'}>
                                    {
                                        this.renderSelections(this.state.availableCountries)
                                    }
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className='row' style={{minHeight: 50 + 'vh'}}>
                        <div className="col-8 mt-5">
                            {this.drawTreeMap()}
                        </div>
                        <div className='col-4 mt-5 pr-5'>
                            {this.renderAtcInfo()}
                        </div>
                    </div>
                    <div className="row mt-4">
                        {
                            this.props.drugsForCountryPerATC
                                ? <div className="col-12">
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align="right">Active Substance</TableCell>
                                                <TableCell align="right">ATC Code</TableCell>
                                                <TableCell align="right">Brand Name</TableCell>
                                                <TableCell align="right">Cost Per Unit</TableCell>
                                                <TableCell align="right">Country Code</TableCell>
                                                <TableCell align="right">Dosage Form</TableCell>
                                                <TableCell align="right">Generic Name</TableCell>
                                                <TableCell align="right">Manufacturer</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {
                                                this.props.drugsForCountryPerATC.map((n, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell align={"right"}>{n.activeSubstance1}</TableCell>
                                                        <TableCell align={"right"}>{n.atcCode}</TableCell>
                                                        <TableCell align={"right"}>{n.brandName}</TableCell>
                                                        <TableCell align={"right"}>{n.costPerUnit}</TableCell>
                                                        <TableCell align={"right"}>{n.countryCode}</TableCell>
                                                        <TableCell align={"right"}>{n.dosageForm}</TableCell>
                                                        <TableCell align={"right"}>{n.genericName1}</TableCell>
                                                        <TableCell align={"right"}>{n.manufacturer1}</TableCell>
                                                    </TableRow>
                                                ))
                                            }
                                        </TableBody>
                                    </Table>
                                </div>
                                : null
                        }
                    </div>
                </div>
            </div>
        );
    }

    generateTooltip(row, size, value) {
        return (
            "<div class='card'>" +
            "<div class='card-body'>" +
            "Drugs: " +
            size +
            "</div>" +
            "</div>"
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onATCCountriesCountFetch: () => dispatch(actions.getATCCountriesCount()),
        onDrugsPerATC: (countryCode) => dispatch(actions.getDrugsPerAtc(countryCode)),
        fetchTable: (countryCode, atcCode) => dispatch(actions.getDrugsForCountryByAtc(countryCode, atcCode))
    }
};


const mapStateToProps = state => {
    return {
        atcCountriesCount: state.drugsStatistics.atcCountriesCount,
        drugsPerATC: state.drugsStatistics.drugsPerATC,
        drugsForCountryPerATC: state.drugs.drugsForCountryPerATC
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ATCStatistics);
